/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Property_ContractInputs */

const cs_model_property_contract = /** @type {(inputs: Model_Property_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouva o nemovitosti`)
};

const en_model_property_contract = /** @type {(inputs: Model_Property_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property contract`)
};

/**
* | output |
* | --- |
* | "Property contract" |
*
* @param {Model_Property_ContractInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const model_property_contract = /** @type {((inputs?: Model_Property_ContractInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Property_ContractInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_model_property_contract(inputs)
	return cs_model_property_contract(inputs)
});